var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAssociationErrorWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 44,
    viewBox: "0 0 53 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.948694 41.0754L0.948647 41.0754L0.94601 41.0799C0.684663 41.5272 0.684663 42.0985 0.94601 42.5457C1.21108 42.9994 1.67564 43.25 2.24094 43.25H50.8535C51.3587 43.25 51.8806 43.0041 52.1484 42.5457L52.1639 42.5192L52.1726 42.4897C52.2927 42.0784 52.3037 41.5192 51.9789 41.0672L27.7073 1.45428C27.7068 1.45351 27.7064 1.45274 27.7059 1.45198C27.4436 1.00493 26.9831 0.75 26.4663 0.75C25.9495 0.75 25.4889 1.00493 25.2267 1.45198C25.2262 1.45274 25.2258 1.45351 25.2253 1.45428L0.948694 41.0754ZM26.466 4.96089L48.1413 40.3756H4.73788L26.466 4.96089Z",
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9755 14.9294V28.6479C24.9755 29.4244 25.6322 30.0587 26.4125 30.0587C27.1927 30.0587 27.8494 29.4244 27.8494 28.6479V14.9294C27.8494 14.1529 27.1927 13.5186 26.4125 13.5186C25.6398 13.5186 24.9755 14.0928 24.9755 14.9294Z",
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4654 35.6935C27.5083 35.6935 28.3538 34.8667 28.3538 33.8467C28.3538 32.8268 27.5083 32 26.4654 32C25.4225 32 24.577 32.8268 24.577 33.8467C24.577 34.8667 25.4225 35.6935 26.4654 35.6935Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssociationErrorWhite);
export default __webpack_public_path__ + "static/media/icon-association-error-white.713d90ccafe43bc2b01fa6ddb8740652.svg";
export { ForwardRef as ReactComponent };